<template>
  <div>
    <campaign :audioUrl="url" :title="title" :author="author" />
  </div>
</template>

<script>
import campaign from "@/components/campaign.vue";
import firebase from "firebase";

export default {
  name: "LiveStream",
  components: { campaign },
  data: function() {
    return {
      url: null,
      author: "",
      title: ""
    };
  },
  created() {
    // var streamId = this.$route.params.id;
    var queryId = this.$route.query.uid;
    this.playLiveStreamUrl(queryId);
  },
  methods: {
    playLiveStreamUrl: function(streamId) {
      var livestreamRef = firebase
        .firestore()
        .collection("library_streams")
        .doc(streamId);
      var _this = this;
      livestreamRef
        .get()
        .then(function(doc) {
          if (doc.exists) {
            var url = doc.data()["mp3Url"];
            var title = doc.data()["title"];
            var author = doc.data()["username"];
            _this.url = url;
            _this.title = title;
            _this.author = author;
          } else {
            console.log("No such document!");
          }
        })
        .catch(function(error) {
          console.log("Error getting document:", error);
        });
    }
  }
};
</script>
